import { Alert, Code, List, Stack, Table, Text } from "@chakra-ui/react";

export const FormatReminder = () => (
  <Alert.Root status="info">
    <Alert.Indicator />
    <Alert.Content>
      <Alert.Title>Format attendu</Alert.Title>
      <Alert.Description>
        <Stack gap={3} mt={2}>
          <Text>
            Un fichier CSV encodé en UTF-8, au format de l'export du marketing. Il contient les
            colonnes suivantes :
          </Text>
          <Table.Root size="sm" variant="outline" maxW="3xl">
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeader>Colonne</Table.ColumnHeader>
                <Table.ColumnHeader>Rôle</Table.ColumnHeader>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <Code>Codes postaux</Code>
                </Table.Cell>
                <Table.Cell>
                  Obligatoire. Une cellule peut porter plusieurs codes postaux.
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <Code>Code commune</Code>
                </Table.Cell>
                <Table.Cell>Obligatoire. C'est le code INSEE.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <Code>Commune</Code>
                </Table.Cell>
                <Table.Cell>Affichée dans l'aperçu.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <Code>Zones</Code>
                </Table.Cell>
                <Table.Cell>Sert à vérifier que le fichier décrit une seule agence.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <Code>Type de zone</Code>
                </Table.Cell>
                <Table.Cell>
                  Facultative. Valeurs : <Code>Coeur zone</Code>, <Code>Proche zone</Code>,{" "}
                  <Code>Hors zone</Code>.
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table.Root>
          <List.Root ps={4}>
            <List.Item>
              Sans la colonne <Code>Type de zone</Code>, toutes les communes sont importées en cœur
              de zone.
            </List.Item>
            <List.Item>
              L'import ajoute ou modifie des rattachements : les communes de l'agence absentes du
              fichier ne changent pas.
            </List.Item>
          </List.Root>
        </Stack>
      </Alert.Description>
    </Alert.Content>
  </Alert.Root>
);
